export default __webpack_public_path__ + "static/media/DSC_7358.f0b9b918.jpg";